// External library imports
import * as yup from 'yup';
// Internal module imports
import { ERRORS } from '../../utils/validationHelper';

export const SymetricalBundleValidation = (isRootUser) => {
    return yup.object().shape({
        name: yup.string().required(ERRORS.required),
        adminId: isRootUser ? yup.string().required(ERRORS.required) : yup.string().optional(),
        market: yup.string().required(ERRORS.required),
        area: yup.string().required(ERRORS.required),
        incInsBundles: yup.array().required(ERRORS.required).min(1),
        decInsBundles: yup.array().required(ERRORS.required).min(1),
    });
};
